// $('.collection-list').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     }

//   ]
// });

$('.feature_slides').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});


/* icon with text slider on home page language translate js */

  function updateContentVisibility() {
      // Get the language set in the <html> tag
      const lang = document.documentElement.lang;

      // Select all content elements for Dutch and English
      const dutchContents = document.querySelectorAll('.netherland-lang');
      const englishContents = document.querySelectorAll('.english-lang');

      // Show or hide content based on language
      if (lang === 'en') {
          englishContents.forEach(element => element.classList.remove('hidden'));
          dutchContents.forEach(element => element.classList.add('hidden'));
      } else if (lang === 'nl') {
          dutchContents.forEach(element => element.classList.remove('hidden'));
          englishContents.forEach(element => element.classList.add('hidden'));
      } else {
          // Optionally handle cases where lang is neither 'en' nor 'nl'
          dutchContents.forEach(element => element.classList.add('hidden'));
          englishContents.forEach(element => element.classList.add('hidden'));
      }
  }

  // Ensure the function runs when the DOM is fully loaded
  document.addEventListener('DOMContentLoaded', updateContentVisibility); 



//******************* Mega menu on hover *************************//

$(document).ready(function() {
 $('.mega-menu__content').hide();
    $('.header__inline-menu .list-menu .main-menu-nav').hover(
        function() {
            $(this).find('.mega-menu__content').stop(true, true).fadeIn(200); 
           $(this).addClass('active');
        },
        function() {
            $(this).find('.mega-menu__content').stop(true, true).fadeOut(200);
          $(this).removeClass('active');
        }
    );
});






